/** Copyright (c) 2019 T. Rowe Price. All rights reserved. */

import './PreferencesMain.scss';

import React, { Fragment } from 'react';
import { connect } from 'react-redux';
import { retailTracEnabled } from 'services/FeatureFlags';
import If from 'components/shared/If/If';
import PreferencesCommunication from 'components/layouts/Preferences/PreferencesCommunications';
import PreferencesHeader from 'components/layouts/Preferences/PreferencesHeader';
import PreferencesFinancial from 'components/layouts/Preferences/PreferencesFinancial';
import PreferencesPeople from 'components/layouts/Preferences/PreferencesPeople';
import PreferencesSection from 'components/layouts/Preferences/shared/PreferencesSection';
import PreferencesSecurity from 'components/layouts/Preferences/PreferencesSecurity';
import {
  getHasWorkPlaceRetirementAccountsOnly,
  getHasRetailTracAccountOnly,
  hasNoOwnedAccounts
} from 'state/account/AccountSelectors';

const PreferencesMain = ({ hasWorkPlaceRetirementAccountsOnly, hasRetailTracAccountOnly, hasNoAccounts }) => (
  <Fragment>
    <PreferencesHeader>
      <div className="customer-name">
        Profile & Settings
      </div>
    </PreferencesHeader>
    <If test={retailTracEnabled()? !hasRetailTracAccountOnly : true}>
        <PreferencesSection>
          <PreferencesPeople />
        </PreferencesSection>
    </If>
    <If test={!hasWorkPlaceRetirementAccountsOnly && !hasNoAccounts}>
      <PreferencesSection>
        <PreferencesFinancial />
      </PreferencesSection>
    </If>

    <PreferencesSection>
      <PreferencesSecurity />
    </PreferencesSection>

   <If test={retailTracEnabled()? !hasRetailTracAccountOnly : true}>
    <PreferencesSection>
      <PreferencesCommunication />
    </PreferencesSection>
   </If>
  </Fragment>
);

const mapStateToProps = (state) => ({
  hasWorkPlaceRetirementAccountsOnly: getHasWorkPlaceRetirementAccountsOnly(state),
  hasRetailTracAccountOnly: getHasRetailTracAccountOnly(state),
  hasNoAccounts: hasNoOwnedAccounts(state)
});

export default connect(mapStateToProps)(PreferencesMain);
